import React, { FC } from 'react'
import Favorite from './Favorite'
import AddToCollection from './AddToCollection'
import AddToCart from './AddToCart'
import styles from './Actions.module.scss'
import { GA4CartEventObject } from './useAddToCart'
import EditArtwork from './EditArtwork'

type PolaroidActionsProps = {
  artworkId: number
  isSold?: boolean
  sku: string
  status: string
  price: number
  productEvent: GA4CartEventObject
  shouldShowEditIcon?: boolean
  customPromoCode?: string
  hasPrints?: boolean
  openAddToCollectionTooltipCentered?: boolean
}

const PolaroidActions: FC<PolaroidActionsProps> = ({
  artworkId,
  isSold,
  sku,
  status,
  price,
  productEvent,
  shouldShowEditIcon,
  customPromoCode,
  hasPrints,
  openAddToCollectionTooltipCentered,
}) => {
  return (
    <div className={styles.polaroidActionsContainer}>
      {shouldShowEditIcon ? (
        <EditArtwork artworkId={artworkId} />
      ) : (
        <Favorite artworkId={artworkId} />
      )}

      <AddToCollection
        artworkId={artworkId}
        shouldOpenCentered={openAddToCollectionTooltipCentered}
      />
      {!isSold && !hasPrints && (
        <AddToCart
          artworkId={artworkId}
          sku={sku}
          status={status}
          price={price}
          productEvent={productEvent}
          customPromoCode={customPromoCode}
        />
      )}
    </div>
  )
}

export default PolaroidActions
